import { LanguageCode } from '../common/Conf';

import type trans from './translations.json';

export type strings = typeof trans.esES;

export const i18n = getStrings(LanguageCode);

export function getStrings(languageCode: string): strings
{
    const trn = require('./translations.json');
    if (trn[languageCode])
        return trn[languageCode]
    return trn['esES']
}


export const dicNames: any = getDicNames(LanguageCode);

export function getDicNames(languageCode: string): strings
{
    switch (languageCode) {
        case 'en':
        case 'enUS':
            return require('./enUS_dics.json');
        default:
            return require('./esES_dics.json');
    }
}
